import { Component, Input, ViewEncapsulation } from '@angular/core';
import { SeverityEnum } from '../../enums/severity.enum';

@Component({
    selector: 'app-wrapper',
    templateUrl: './wrapper.component.html',
    styleUrls: ['./wrapper.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class WrapperComponent {
    @Input() public severity: SeverityEnum = SeverityEnum.INFO;
}
